import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

interface ISecondDoorContentProps extends TDoor {
  secondBtn?: {
    btnText: string;
    onSecondBtn: VoidFunction;
  };
  firstBtnClicked?: boolean;
}

export const SecondDoorContent: React.FC<ISecondDoorContentProps> = props => {
  return (
    <DoorContent btnText="Перейти в Telegram" {...props}>
      <div>
        <i>
          Сегодня у вас есть шанс не только получить полезный инструмент, но и выиграть один из 10 новогодних подарков
          от Циан.Посуточно.
        </i>
      </div>
      <div>
        <div>
          <b>🎁 Приглашаем в конкурс!</b>
        </div>
        Станьте участником конкурса в нашем сообществе хостов в Telegram и получите шанс выиграть специальный приз.
      </div>
      <div>
        <b>И полезный бонус уже сейчас!</b> Каждый участник конкурса сразу получит подробную статью с практическими
        рекомендациями, как украсить ваш объект к Новому году — чтобы создать гостям по-настоящему праздничную
        атмосферу.
      </div>
      <div>
        <b>
          Участвуйте в конкурсе и получите готовый план, как превратить новогоднее оформление в преимущество вашего
          объекта.
        </b>
      </div>
    </DoorContent>
  );
};
